const NAVBAR_LINK_CLASS_NAME = 'navbar-link';
const NAVBAR_PROFILE_CLASS_NAME = 'navbar-profile';
const TAB_LINK_CLASS_NAME = 'tab-link';
const PRIMARY_LINK_CLASS_NAME = 'primary-link';
const MIN_WIDTH_FROM_TAB_COUNT = 'min-width-from-tab-count';
const DEFAULT_LINK_CLASS_NAME = 'default-link';
const NAVBAR_ROUTE_CLASS_NAME = 'navbar-route';
export {
  NAVBAR_LINK_CLASS_NAME,
  NAVBAR_PROFILE_CLASS_NAME,
  TAB_LINK_CLASS_NAME,
  PRIMARY_LINK_CLASS_NAME,
  MIN_WIDTH_FROM_TAB_COUNT,
  DEFAULT_LINK_CLASS_NAME,
  NAVBAR_ROUTE_CLASS_NAME,
};
